import * as yup from "yup";

import { useAuth, useHookForm } from "../../../hooks";
import { IInitTransactionRequest } from "../../../interfaces-and-types";
import { globalHandlerUtils } from "../../../utils";
import { IPaymentLinkPreviewProps } from "../PaymentLinkPreview/PaymentLinkPreview";

import { View } from "./View";

export const InlinePaymentLinkPagePreview = (
  props: IPaymentLinkPreviewProps
) => {
  const authContext = useAuth();
  const merchant_name = authContext.staff_departments.find(
    (d) => d.merchant_id === authContext.active_tenant_id
  )?.merchant_name;

  const initialFormValues: IInitTransactionRequest = {
    tx_ref: "123456789",
    currency: "NGN",
    amount: 300,
    redirect_url: "http://dashboard.switchappgo.com",
    customer: {
      full_name: "First Customer",
      email: "testcustomer@gmail.com",
      phone_number: "08035079065",
    },
  };

  const transactionSchema: yup.SchemaOf<IInitTransactionRequest> = yup
    .object({
      tx_ref: yup.string().required("TxRef is required"),
      currency: yup.string().required("Currency is required"),
      amount: yup.number().required("Amount is required"),
      redirect_url: yup.string().required("Redirect Url is required"),
      swAppPaymentLinkId: yup.string().nullable().optional(),
      customer: yup
        .object({
          email: yup.string().required("Customer Email is required"),
          full_name: yup.string().nullable().optional(),
          address: yup.string().nullable().optional(),
          phone_number: yup.string().nullable().optional(),
        })
        .required("Customer is required"),
    })
    .required();

  const handleApiSubmit = (data: IInitTransactionRequest) => {};

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, errors, register, reset } = useHookForm({
    initialFormValues,
    validationSchema: transactionSchema,
    onValid: handleApiSubmit,
    onInvalid: handleError,
  });

  const currency = props.paymentLinkToPreview.currency;
  const amount = props.paymentLinkToPreview.line_items
    .filter((pl) => pl.product)
    .reduce(
      (acc, curr) =>
        acc +
        curr.qty *
          props.productsInPaymentLink.find((p) => p.id === curr.product)!.price,
      0
    );

  return (
    <View
      {...props}
      merchant_name={merchant_name || ""}
      currency={currency}
      amount={amount}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
    />
  );
};
